var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-tooltip',{staticClass:"pointer"},[_c('template',{slot:"title"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.txt)}})]),_c('img',{staticClass:"tooltip_img",attrs:{"width":"12px","src":require("@/assets/auto_img/information-circle@2x (1).png"),"alt":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }